import React, { useState, useMemo } from "react";
import ReactDOM from "react-dom";
import { useFetch } from "../hooks/useFetch";
import UserLister from "./userLister";
import Loading from "../Loading";
import { useTableManager } from "../hooks/useTableManager"; 

const SEARCH_KEYS = [
    'userDetails.userEmail', 
    'userDetails.userName.firstName', 
    'userDetails.userName.lastName', 
    'userDetails.organization'
];

export default function WildcardLister({ displayRef, tableRef, query, em, token }) {
    const url = "api/user/wildcard/" + encodeURIComponent(query);
    const res = useFetch(url, token);
    const {
        requestSort, getSortIndicator,
        currentPage, setCurrentPage, handleNextPage, handlePrevPage,
        itemsPerPage, setItemsPerPage,
        currentData, totalItems, totalPages, startIndex
    } = useTableManager(res.response?.users || [], SEARCH_KEYS, 'userDetails.userName.firstName', 'asc');

    // Early returns are now safely placed below all Hooks
    if (res.response === null) {
        return <Loading />;
    }

    if (res.response.success === false || !res.response.users || res.response.users.length === 0) {
        return <h4 style={{ color: "red", marginTop: "20px" }}>No users found matching "{query}"</h4>;
    }
    
    const handleSelect = (selectedEmail) => {
        try {
            ReactDOM.render(
                <UserLister 
                    displayRef={displayRef} 
                    query={selectedEmail} 
                    em={em} 
                    token={token} 
                />, 
                tableRef.current
            );
        } catch (err) {
            alert(err);
        }
    };

    return (
        <div className="App" id="" style={{ marginTop: "20px", width: "100%" }}> 
            <div style={{
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                marginBottom: "15px"
            }}>
                <h5>{totalItems} Wildcard Results for "{query}"</h5>
                
                <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "8px", fontSize: "14px" }}>Show entries:</span>
                    <select 
                        className="form-select form-select-sm" 
                        style={{ width: "80px" }}
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(parseInt(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            </div>

            <table className="table table-striped table-bordered mb-2">
                <thead className="table-header">
                    <tr style={{ backgroundColor: "#f8f9fa" }}>
                        <th scope="col" onClick={() => requestSort('userDetails.userEmail')} style={{ cursor: "pointer", userSelect: "none" }}>
                            Email {getSortIndicator('userDetails.userEmail')}
                        </th>
                        <th scope="col" onClick={() => requestSort('userDetails.userName.firstName')} style={{ cursor: "pointer", userSelect: "none" }}>
                            First Name {getSortIndicator('userDetails.userName.firstName')}
                        </th>
                        <th scope="col" onClick={() => requestSort('userDetails.userName.lastName')} style={{ cursor: "pointer", userSelect: "none" }}>
                            Last Name {getSortIndicator('userDetails.userName.lastName')}
                        </th>
                        <th scope="col" onClick={() => requestSort('userDetails.organization')} style={{ cursor: "pointer", userSelect: "none" }}>
                            Organization {getSortIndicator('userDetails.organization')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentData.map((v, i) => (    
                        <tr key={i}>
                            <td>           
                                <div>
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleSelect(v.userDetails?.userEmail || query);
                                        }}>
                                        {v.userDetails?.userEmail || "Missing Email"}
                                    </button>
                                </div>
                            </td>  
                            <td>{v.userDetails?.userName?.firstName || ""}</td>
                            <td>{v.userDetails?.userName?.lastName || ""}</td>
                            <td>{v.userDetails?.organization || "N/A"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                padding: "10px 5px",
                width: "100%"
            }}>
                <div className="text-muted" style={{ fontSize: "14px" }}>
                    Showing <b>{totalItems === 0 ? 0 : startIndex + 1}</b> to <b>{Math.min(startIndex + itemsPerPage, totalItems)}</b> of <b>{totalItems}</b> entries
                </div>
                
                {totalPages > 1 && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <button 
                            className="btn btn-sm btn-outline-secondary" 
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            style={{ marginRight: "10px" }}
                        >
                            Previous
                        </button>
                        
                        <span style={{ fontSize: "14px" }}>
                            Page <b>{currentPage}</b> of {totalPages}
                        </span>
                        
                        <button 
                            className="btn btn-sm btn-outline-secondary" 
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            style={{ marginLeft: "10px" }}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}